<app-modal-container>
  <header header class="flex items-center justify-between p-4 bg-zinc-50 lg:rounded-t-2xl w-full lg:max-w-sm">
    <p class="sb-aggro text-sm text-zinc-800">{{ events().length }} 건</p>
    <button (click)="close()" class="flex items-center cursor-pointer">
      <app-icon name="material-symbols:close" class="size-5! text-zinc-400" />
    </button>
  </header>

  <div class="p-4 flex flex-col gap-4 w-full lg:max-w-sm">
    @for (event of events(); track event.id; let last = $last) {
    <button
      class="group cursor-pointer flex gap-2 items-start relative"
      [routerLink]="['/event', event.id]"
      (click)="close()">
      <div class="flex-1 flex flex-col gap-1 items-start">
        <div class="flex gap-1">
          <app-icon name="material-symbols:check-circle" class="size-4! text-secondary-500" />
          <p class="text-sm text-zinc-800 sb-aggro font-light">
            {{ event.title }}
          </p>
        </div>
        <p class="text-sm text-zinc-600">{{ event.place.name }}</p>
        <p class="text-xs text-zinc-400">
          {{ formatDateRangeShort(event.startAt, event.endAt) }}
        </p>
      </div>
      <app-icon
        name="material-symbols:arrow-outward-rounded"
        class="size-5! text-zinc-400 group-hover:text-orange-500 transition-colors shrink-0" />
    </button>
    @if (!last) {
    <div class="border-b border-zinc-200"></div>
    } }
  </div>
</app-modal-container>
